module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    staticClass: "hidden-md-and-down",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isManager('project') && _vm.isTowerCo()),
      expression: "isManager('project') && isTowerCo()"
    }],
    attrs: {
      "icon": "fa fa-trash-alt",
      "size": "small",
      "type": "danger",
      "circle": "",
      "disabled": _vm.isViewOnly()
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff297468"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/RtxActionDeleteControl.vue
// module id = 1661
// module chunks = 0